// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__gEQqL","loaderContent":"Loader_loaderContent__6hmBk","dots":"Loader_dots__+HN2T","dotFlashing":"Loader_dotFlashing__1sUeH"};